import { CategoryType } from "../../components/CategorySelect";
import { Pagination } from "./common";
import { API_URL } from "../config";

export interface Video {
    title: string;
    href: string;
    img: string;
    dateDiff: string;
    duration: string;
}

export interface RecommendedResult {
    pagination: Pagination;
    videos: Video[];
}

export async function recommended(
    category: CategoryType
): Promise<RecommendedResult> {
    return await (
        await fetch(
            API_URL +
                "/recommended?" +
                new URLSearchParams({ category }).toString()
        )
    ).json();
}
